import { render, staticRenderFns } from "./bczn.vue?vue&type=template&id=24406e9d&scoped=true&"
import script from "./bczn.vue?vue&type=script&lang=js&"
export * from "./bczn.vue?vue&type=script&lang=js&"
import style0 from "./bczn.vue?vue&type=style&index=0&id=24406e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24406e9d",
  null
  
)

export default component.exports